var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack520({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.42,7.06H9.58v3.62a3.39,3.39,0,0,1-.13,1.09,1.5,1.5,0,0,1-.61.81,2,2,0,0,1-1.16.3,1.76,1.76,0,0,1-1.31-.47A2,2,0,0,1,5.91,11L7,10.89a1.47,1.47,0,0,0,.15.69.61.61,0,0,0,.57.31.61.61,0,0,0,.54-.22,1.7,1.7,0,0,0,.16-.91Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack520);
export default __webpack_public_path__ + "static/media/Symbolpack_5_20.60838a42b8609ea667eb5892c4a2801c.svg";
export { ForwardRef as ReactComponent };